import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { restoreWorkspaceQuizzes } from '../../../api/workspaces/quizzes/restoreWorkspaceQuizzes';

export function useRestoreWorkspaceQuizzes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: restoreWorkspaceQuizzes,
    onSettled: async (_data, _error, { workspaceId }) => {
      return Promise.all([
        queryClient.invalidateQueries(workspaceKeys.allQuizzes(workspaceId)),
        queryClient.invalidateQueries(workspaceKeys.list()),
      ]);
    },
  });
}
